import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      toPathName: null,
      isBackNavigation: false
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE'
    }),
    localeParams () {
      return {
        locale: this.locale === 'en' ? 'en' : undefined
      }
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.onScroll)
    // this.onScroll()

    window.addEventListener('popstate', () => {
      this.isBackNavigation = true
    })

    this.$router.afterEach((to, from) => {
      this.hideHeader = false
      window.removeEventListener('scroll', this.onScroll)

      if (this.isBackNavigation) {
        this.isBackNavigation = false // 상태를 초기화
      } else {
        setTimeout(() => {
          if (to.path !== from.path && to.path === this.toPathName) {
            // 추가 작업 실행

            const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
            const navigationTab = document.querySelector('.navigation-tab')
            // console.log('페이지 로드 완료', navigationTab)

            if (navigationTab) {
              window.scrollTo({
                top: navigationTab.offsetTop - headerHeight,
                behavior: 'instant'
              })
            }
          }

          setTimeout(() => {
            window.addEventListener('scroll', this.onScroll)
          }, 100)
        }, 1)
      }
    })

    this.$root.$on('header:show', () => {
      this.hideHeader = false
    })
  },
  methods: {
    onScroll () {
      const offset = window.scrollY || window.pageYOffset
      const offsetGap = 2

      if (offset <= 0) {
        this.hideHeader = false
        return
      }

      this.percent = Math.round(offset / (document.documentElement.scrollHeight - document.documentElement.clientHeight) * 100)

      if (this.scrollOffset - offset < offsetGap * -1) {
        this.hideHeader = true
      } else if (this.scrollOffset - offset > offsetGap) {
        this.hideHeader = false
      }

      this.scrollOffset = offset
    },
    goPageAnchor (e) {
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
      const navigationTab = document.querySelector('.navigation-tab')
      this.toPathName = e.target.pathname
      this.isHeaderOpen = false

      if (this.toPathName === this.$route.path && navigationTab) {
        window.scrollTo({
          top: navigationTab.offsetTop - headerHeight,
          behavior: 'smooth'
        })
      }

      this.$refs.globalNav && this.$refs.globalNav.classList.remove('hover')
    }
  }
}
